export default __webpack_public_path__ + "static/media/bash.00caddaf.png";